<template>
    <div class="course_header_bar_div" :style="bg_color" v-if="course_info">
        <!--
            title type
            student follow author
         -->
        <div class="course_header_bar_layout_div">
            <div class="course_header_bar_course_info_top">
                <span class="course_header_bar_course_title ellipsis">{{ course_info.name }}</span>
                <!--<span class="course_type_span"-->
                <!--:class="course_type_class[course_info.fee_type]">-->
                <!--{{ type_dict[course_info.fee_type] }}-->
                <!--</span>-->
            </div>
            <div class="course_header_bar_course_info_bottom">
                <span v-if="lesson_info && lesson_info.lesson_name">§ {{ lesson_info.lesson_name }} </span>
                <span class="span_split">主讲: {{ course_info.teacher.name }} </span>
                <span v-if="course_info.students_count>=10"
                      class="span_split">{{ course_info.students_count }} 人学过 </span>
                <span v-if="course_info.followers_count>=10"
                      class="span_split">{{ course_info.followers_count }} 人收藏</span>
            </div>
        </div>

    </div>
</template>
<script type="text/javascript">
    import {mapState} from 'vuex'

    export default {
        data() {
            return {
                course_type_class: {
                    'free': 'free_course_p',
                    'member': 'vip_course_p',
                    'bootcamp': 'training_course_p',
                    '': ''
                },
                type_dict: {
                    'free': '免费',
                    'member': '会员',
                    'bootcamp': '训练营'
                }
            }
        },
        computed: {
            ...mapState({
                course_info: state => state.course.course_information,
                lesson_info: state => state.learning.lesson_info,
            }),
            bg_color: function () {
                if (!this.course_info) {
                    return ''
                }
                return 'background: ' + this.course_info['header_bg_color'] + ';'
            }
        }
    }
</script>
<style type="text/css" scoped>
    /* course_type css设计 */
    .course_type_span {
        display: inline-block;
        line-height: 1.6;
        color: #fff;
        padding: 0 6px;
        border-radius: 73px;
        font-size: 13px;
        margin-left: 8px;
    }

    .free_course_p {
        background: #80c269;
    }

    .training_course_p {
        background: #f66e6e;
    }

    .vip_course_p {
        background: #ffae0f;
    }

    /*  */
    .course_header_bar_div {
        width: 100%;
        /*height: 72px;*/
        background: #333;
        padding: 6px 0 0 30px;
        color: #fff;
        transition: opacity 1s;
        z-index: 8;
    }

    .course_header_bar_layout_div {
        /*width: 1170px;*/
        margin: auto;
    }

    .course_header_bar_course_title {
        font-size: 22px;
        line-height: 1.6;
        font-weight: 500;
    }

    .course_header_bar_course_info_bottom {
        font-size: 14px;
    }

    .span_split:before {
        content: "";
        background: #eee;
        width: 1px;
        height: 20px;
        display: inline-block;
        margin: 0 8px -4px 4px;
    }

    @media screen and (max-width: 700px) {
        .course_header_bar_div {
            padding-left: 5px;
        }
    }

    .ellipsis {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        word-break: break-all;
    }
</style>
